import React, { useState, useEffect } from "react";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import AnnualMenu from "./AnnualMenu";
import { NavLink } from "react-router-dom";
import { scrollToTop } from "../Shared/ScrollOnTop";
import { toast, ToastContainer } from "react-toastify";
import config from "../../Config";

function AddClassesInSessions(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [loadingSessions, setLoadingSessions] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [sourceSessionId, setSourceSessionId] = useState(0);
  const [targetSessionId, setTargetSessionId] = useState(0);
  const [resultMessage, setResultMessage] = useState("");

  document.title = "Add Classes In Sessions";

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    const apiData = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      PageNo: 1,
      PageSize: 1000,
      SchoolID: 1,
    };

    setLoadingSessions(true);
    const api_config = {
      method: "post",
      url: config.base_url + "AcademicSession/GetAcademicSessions",
      headers: {
        "Content-Type": "application/json",
      },
      data: apiData,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          const list = response.data.ListofRecords || [];
          setSessions(list);
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoadingSessions(false);
      })
      .catch(function () {
        setLoadingSessions(false);
        toast.error("Failed to load academic sessions.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [AccessKey, UserID, MemberType]);

  useEffect(() => {
    if (!sessions || sessions.length === 0) {
      return;
    }

    const sortedSessions = [...sessions].sort(
      (a, b) => a.Session_ID - b.Session_ID
    );
    const latestSession = sortedSessions[sortedSessions.length - 1];
    const defaultSessionId = parseInt(
      localStorage.getItem("DefaultSession") || "0",
      10
    );

    if (sourceSessionId === 0) {
      let initialSource = defaultSessionId || 0;
      if (initialSource === 0) {
        initialSource =
          sortedSessions.length > 1
            ? sortedSessions[sortedSessions.length - 2].Session_ID
            : latestSession.Session_ID;
      }
      if (initialSource === latestSession.Session_ID && sortedSessions.length > 1) {
        initialSource = sortedSessions[sortedSessions.length - 2].Session_ID;
      }
      setSourceSessionId(initialSource);
    }

    if (targetSessionId === 0) {
      setTargetSessionId(latestSession.Session_ID);
    }
  }, [sessions, sourceSessionId, targetSessionId]);

  const getSessionName = (sessionId) => {
    const session = sessions.find(
      (item) => parseInt(item.Session_ID, 10) === parseInt(sessionId, 10)
    );
    return session ? session.Session_Name : "";
  };

  const handleAddClassesInSession = () => {
    if (!sourceSessionId || !targetSessionId) {
      toast.warning("Please select both source and target sessions.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    if (parseInt(sourceSessionId, 10) === parseInt(targetSessionId, 10)) {
      toast.warning("Source and target sessions must be different.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const sourceName = getSessionName(sourceSessionId);
    const targetName = getSessionName(targetSessionId);
    const confirmation = window.confirm(
      `Copy classes, sections, and fee structures from "${sourceName}" to "${targetName}"?`
    );
    if (!confirmation) {
      return;
    }

    setLoading(true);
    setResultMessage("");
    const apiData = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      SourceSessionID: parseInt(sourceSessionId, 10),
      TargetSessionID: parseInt(targetSessionId, 10),
      SessionID: parseInt(sourceSessionId, 10),
      SchoolID: 1,
    };

    //console.log(apiData);
    var api_config = {
      method: "post",
      url: config.base_url + "AnnualTask/AddClassesInSession",
      headers: {
        "Content-Type": "application/json",
      },
      data: apiData,
    };

    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        if (response.data.status_code == 1) {
          setResultMessage(response.data.status_message);
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          setResultMessage(response.data.status_message);
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        toast.error("Failed to generate classes.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <>
      <AnnualMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Home/Index">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/AnnualTasks/AnnualTasksDashboard">
                        Annual Tasks{" "}
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add Classes In Sessions
                    </li>
                  </ol>
                </nav>
                <div className="page-title">
                  Generate Classes And Sections In New Academic Session
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body p-md-4">
                <div className="bg-light p-md-4 rounded-2">
                  <p>
                    Copy classes, sections, and fee structures from an existing
                    academic session into a new academic session.
                  </p>
                  <b>Pre-Requirements:</b>
                  <p>
                    Make sure the target academic session already exists, and does
                    not have any classes yet.
                  </p>
                  <div className="row g-3 align-items-end">
                    <div className="col-md-4">
                      <label className="form-label">Source Session</label>
                      <select
                        className="form-select"
                        value={sourceSessionId}
                        onChange={(e) => setSourceSessionId(e.target.value)}
                        disabled={loadingSessions}
                      >
                        <option value="0">Select Source Session</option>
                        {(sessions || []).map((item) => (
                          <option key={item.Session_ID} value={item.Session_ID}>
                            {item.Session_Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Target Session</label>
                      <select
                        className="form-select"
                        value={targetSessionId}
                        onChange={(e) => setTargetSessionId(e.target.value)}
                        disabled={loadingSessions}
                      >
                        <option value="0">Select Target Session</option>
                        {(sessions || []).map((item) => (
                          <option key={item.Session_ID} value={item.Session_ID}>
                            {item.Session_Name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="mt-3">
                    <small className="text-muted">
                      Fee details (A/M) for each class will also be copied into
                      the target session.
                    </small>
                  </div>
                  {resultMessage && (
                    <div className="alert alert-info mt-3 mb-0">
                      {resultMessage}
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-3 text-end mt-3">
                      <button
                        type="submit"
                        onClick={handleAddClassesInSession}
                        value="GenerateClasses"
                        className="button button-primary w-100"
                        disabled={loading || loadingSessions}
                      >
                        {loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Generate Classes"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddClassesInSessions;
